"use client"

import { Underline } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `UnderlineIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const UnderlineIcon = component(Icon)({ as: Underline })
